const changeNavbarBackgroundColor = () => {
    if(document.querySelector('.stoof-navbar')){
        const bar = document.querySelector('.stoof-navbar');
        bar.addEventListener('shown.bs.dropdown', ev => {
            if(!bar.classList.contains('stoof-navbar__active')){
                bar.classList.add('stoof-navbar__active');
            }
        });
        bar.addEventListener('hidden.bs.dropdown', ev => {
            if(bar.classList.contains('stoof-navbar__active') && bar.querySelectorAll('.show').length < 1){
                bar.classList.remove('stoof-navbar__active');
            }
        })
    }
}
export default changeNavbarBackgroundColor;